import "./ReliefAndTerrainDigitalModelsCreation.module.css";
import Header from "@/reusable_sections/Header";
import RepairDelayInformation from "./sections/RepairDelayInformation";
import ServiceDetailsFrameRepair from "./sections/ServiceDetailsFrameRepair";
import ContactSection from "./sections/ContactSection";
import PhotogrammetryServicesGrid from "./sections/PhotogrammetryServicesGrid";
import Footer from "@/reusable_sections/Footer";
export default function ReliefAndTerrainDigitalModelsCreationPage() {
  return <div>
      <Header />
      <RepairDelayInformation />
      <ServiceDetailsFrameRepair />
      <ContactSection />
      <PhotogrammetryServicesGrid />
      <Footer />
    </div>;
}